/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".example-container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.example-container[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{width:100%}\n/*# sourceMappingURL=register-machine.component.css.map*/"];
export { styles as styles };
